define('ngss_correlations', ['TableCarousel'], function(TableCarousel) {
  if ($('.lesson-column').length > 6) {
    TableCarousel.init();
  }
});
